import React from "react";
import { Styles } from "./styles";
import MainButton from "../../../common/buttons/mainButton/MainButton";
import { t } from "i18next";

const ControlButtons = (props) => {
  const {
    isJoined,
    leaveChannel,
    isFullScreen,
    toggleFullScreen,
    isScreenVideoPubed,
    canPublishVideo,
    startScreenShare,
    stopScreenShare,
    isMobileDevice,
    isAudioPubed,
    canPublishAudio,
    publishAudio,
    isVideoPubed,
    publishVideo,
    isAudience,
    isHandRaised,
    RaiseHand,
    PutHandDown,
  } = props;
  return (
    <Styles>
      <div className="buttons">
        {isAudience ? (
          <div
            className={isAudioPubed ? "btn-container" : "btn-container danger"}
          >
            <MainButton
              buttonClick={publishAudio}
              buttonDisabled={!canPublishAudio}
              buttonText={
                isAudioPubed ? (
                  <i className="fa-solid fa-microphone-lines"></i>
                ) : (
                  <i className="fa-solid fa-microphone-lines-slash"></i>
                )
              }
            />
            {t("mic")}
          </div>
        ) : (
          <>
            <div
              className={
                isVideoPubed ? "btn-container" : "btn-container danger"
              }
            >
              <MainButton
                buttonClick={publishVideo}
                buttonDisabled={!canPublishVideo}
                buttonText={
                  isVideoPubed ? (
                    <i className="fa-solid fa-video"></i>
                  ) : (
                    <i className="fa-solid fa-video-slash"></i>
                  )
                }
              />
              {t("cam")}
            </div>
            <div
              className={
                isAudioPubed ? "btn-container" : "btn-container danger"
              }
            >
              <MainButton
                buttonClick={publishAudio}
                buttonDisabled={!canPublishAudio}
                buttonText={
                  isAudioPubed ? (
                    <i className="fa-solid fa-microphone-lines"></i>
                  ) : (
                    <i className="fa-solid fa-microphone-lines-slash"></i>
                  )
                }
              />
              {t("mic")}
            </div>
            {!isMobileDevice && (
              <div
                className={
                  isScreenVideoPubed ? "btn-container" : "btn-container danger"
                }
              >
                <MainButton
                  buttonClick={
                    isScreenVideoPubed ? stopScreenShare : startScreenShare
                  }
                  buttonDisabled={!canPublishVideo}
                  buttonText={
                    isScreenVideoPubed ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 256 256"
                        id="screencast"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <path
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="16"
                          d="M31.99414 96V56a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8V200a8 8 0 0 1-8 8h-72M31.99414 192a16 16 0 0 1 16 16M31.99414 160a48 48 0 0 1 48 48M31.99414 128a80 80 0 0 1 80 80"
                        ></path>
                      </svg>
                    ) : (
                      <div className="stop">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 256 256"
                          id="screencast"
                        >
                          <rect width="256" height="256" fill="none"></rect>
                          <path
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="16"
                            d="M31.99414 96V56a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8V200a8 8 0 0 1-8 8h-72M31.99414 192a16 16 0 0 1 16 16M31.99414 160a48 48 0 0 1 48 48M31.99414 128a80 80 0 0 1 80 80"
                          ></path>
                        </svg>
                      </div>
                    )
                  }
                />
                {t("share")}
              </div>
            )}
          </>
        )}

        <div className="btn-container">
          <MainButton
            buttonClick={toggleFullScreen}
            buttonText={
              isFullScreen ? (
                <i className="fa-solid fa-compress"></i>
              ) : (
                <i className="fa-solid fa-expand"></i>
              )
            }
          />
          {t("full_screen")}
        </div>
        <div
          className={
            isHandRaised
              ? "btn-container raise-hand"
              : "btn-container raise-hand danger"
          }
        >
          <MainButton
            buttonClick={isHandRaised ? PutHandDown : RaiseHand}
            buttonText={
              isHandRaised ? (
                <i className="fa-solid fa-hand"></i>
              ) : (
                <div className="stop">
                  <i className="fa-solid fa-hand"></i>
                </div>
              )
            }
          />
          {t("raise_hand")}
        </div>
        <div className="btn-container">
          <MainButton
            buttonClick={leaveChannel}
            buttonDisabled={!isJoined}
            buttonText={
              <i className="fa-solid fa-arrow-right-from-bracket"></i>
            }
          />
          {t("leave")}
        </div>
      </div>
    </Styles>
  );
};

export default ControlButtons;
